import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format date to French Canadian format
export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('fr-CA', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);
}

// Format date with time
export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('fr-CA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

// Format file size
export function formatFileSize(bytes) {
  if (bytes === 0) return '0 octet';
  const k = 1024;
  const sizes = ['octets', 'Ko', 'Mo', 'Go'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

// Get status label in French
export function getStatusLabel(status) {
  const labels = {
    'recu': 'Reçu',
    'en_cours_revision': 'En cours de révision',
    'approuve': 'Approuvé',
    'refuse': 'Refusé',
    'a_completer': 'À compléter',
    // Legacy statuses for backward compatibility
    'en_attente': 'En attente',
    'rejete': 'Refusé',
    'revision': 'En cours de révision',
    // Project statuses
    'actif': 'Actif',
    'termine': 'Terminé',
    'suspendu': 'Suspendu',
  };
  return labels[status] || status;
}

// Get event type label in French
export function getEventTypeLabel(type) {
  const labels = {
    'televersement': 'Téléversement',
    'telechargement': 'Téléchargement',
    'changement_statut': 'Changement de statut',
    'suppression': 'Suppression',
    'nouvelle_version': 'Nouvelle version',
    'document_requis_cree': 'Document requis créé',
    'document_requis_televerse': 'Document requis téléversé',
  };
  return labels[type] || type;
}

// Get role label in French
export function getRoleLabel(role) {
  const labels = {
    'administrateur': 'Administrateur',
    'employe': 'Employé',
    'client': 'Client',
  };
  return labels[role] || role;
}

// Get approval status label in French
export function getApprovalStatusLabel(status) {
  const labels = {
    'approuve': 'Approuvé',
    'refuse': 'Refusé',
    'corrections_demandees': 'Corrections demandées',
    'en_attente': 'En attente',
  };
  return labels[status] || status;
}

// Get message type label
export function getMessageTypeLabel(type) {
  const labels = {
    'nouveau_message': 'Nouveau message',
    'reponse': 'Réponse',
  };
  return labels[type] || type;
}

// Get client status label
export function getClientStatusLabel(status) {
  const labels = {
    'actif': 'Actif',
    'inactif': 'Inactif',
  };
  return labels[status] || status;
}

// Format relative time in French
export function formatRelativeTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return "À l'instant";
  if (diffMins < 60) return `Il y a ${diffMins} min`;
  if (diffHours < 24) return `Il y a ${diffHours}h`;
  if (diffDays < 7) return `Il y a ${diffDays}j`;
  return formatDate(dateString);
}
